import { useEffect, useState, useMemo } from "react";
import { Outlet } from "react-router-dom";
import { AppProvider } from "@toolpad/core/react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";
import { createTheme } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import logo from "./images/SCY W+Color.png";
import { useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";

const theme = createTheme({
  typography: {
    fontFamily: '"IBM Plex Sans Thai", serif',
  },
  cssVariables: {
    colorSchemeSelector: "data-toolpad-color-scheme",
  },
  colorSchemes: { light: true },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#c69fe1ff",
          color: "#fff",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          "& .MuiTypography-root": {
            color: "#ffffff",
            fontWeight: "bold",
            fontSize: "1.25rem",
          },
          "&.Mui-selected": {
            backgroundColor: "#FCDE70",
            "&:hover": {
              backgroundColor: "#E8B86D",
            },
          },
        },
      },
    },
  },
});

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const firstSegment = pathSegments[0];

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);

        // ตรวจสอบเวลาหมดอายุ (exp) กับเวลาปัจจุบัน
        const currentTime = Date.now() / 1000;

        if (decoded.exp < currentTime) {
          console.log("Token has expired");
          navigate("/auth/login");
        } else {
          setSession({
            user: {
              name: decoded.username,
              email: decoded.username + "@gmail.com",
              // image: <AccountCircleIcon />,
            },
          });
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        navigate("/auth/login");
      }
    } else {
      console.log("No access token found");
      if (firstSegment !== "receipt") {
        navigate("/auth/login");
      }
    }
  }, [firstSegment, navigate]);

  const [session, setSession] = useState({});

  const authentication = useMemo(() => {
    return {
      signIn: () => {
        setSession({
          user: {
            name: "",
            email: "",
            image: <AccountCircleIcon />,
          },
        });
      },
      signOut: async () => {
        await auth.signOut();
        localStorage.removeItem("accessToken");
        setSession(null);
        navigate("/auth/login");
      },
    };
  }, [navigate]);

  return (
    <AuthProvider>
      <AppProvider
        theme={theme}
        session={session}
        authentication={authentication}
        branding={{
          logo: <img src={logo} alt=" Logo" style={{ marginRight: 10 }} />,
          title: "",
        }}
      >
        <Outlet />
      </AppProvider>
    </AuthProvider>
  );
}
